import { z } from 'zod';
/**
 * Prestataire du paiement en plusieurs fois (3x/4x).
 * Bascule runtime via le backoffice (table app_settings, clé `installment_provider`).
 */
export const installmentProviderSchema = z.enum(['FLOA', 'SSP']);
export const updatePaymentSettingsSchema = z.object({
    installmentProvider: installmentProviderSchema,
});
